(function() {
  document.addEventListener('DOMContentLoaded', function() {

    // 1. EU vs. International delivery date
    var deliveryEl = document.querySelector('.estimate-delivery');
    if (deliveryEl) {
      var countryMeta = document.querySelector('meta[name="shopify-country"]');
      var country = countryMeta ? countryMeta.getAttribute('content') : '';
      var euCountries = ['AT','BE','BG','CY','CZ','DE','DK','EE','ES','FI','FR','GR','HR','HU','IE','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK'];
      var isEU = euCountries.indexOf(country) !== -1;
      if (!isEU) {
        deliveryEl.textContent = 'Internationale Lieferung: ca. 3 Wochen';
      } else {
        var fullText = deliveryEl.textContent.trim();
        var colonIdx = fullText.lastIndexOf(':');
        if (colonIdx !== -1) {
          var label = fullText.substring(0, colonIdx + 1).trim();
          var dateStr = fullText.substring(colonIdx + 1).trim().replace(/\s+/g, ' ');
          var currentYear = new Date().getFullYear();
          var parsedDate = new Date(dateStr + ', ' + currentYear);
          if (!isNaN(parsedDate.getTime())) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            if (parsedDate < today) parsedDate.setFullYear(currentYear + 1);
            var day = String(parsedDate.getDate()).padStart(2, '0');
            var month = String(parsedDate.getMonth() + 1).padStart(2, '0');
            var year = parsedDate.getFullYear();
            deliveryEl.textContent = label + ' ' + day + '.' + month + '.' + year;
          }
        }
      }
    }

    // 2. Preis neben Titel
    var titleHead = document.querySelector('.product__head');
    var titleWrapper = titleHead ? titleHead.querySelector('.product__title__wrapper') : null;
    if (titleWrapper) {
      var priceBlock = titleHead.nextElementSibling;
      var priceEl = priceBlock ? priceBlock.querySelector('[id^="Price-"]') : null;
      if (priceEl) {
        titleWrapper.style.display = 'flex';
        titleWrapper.style.justifyContent = 'space-between';
        titleWrapper.style.alignItems = 'center';
        titleWrapper.style.gap = '16px';
        var inlinePrice = document.createElement('div');
        inlinePrice.className = 'product__inline-price';
        inlinePrice.appendChild(priceEl);
        titleWrapper.appendChild(inlinePrice);
        if (priceBlock) priceBlock.style.display = 'none';
      }
    }

    // 3. XB Wishlist Herz auf das Produktbild
    function setupHeartButton(xbBtn) {
      if (xbBtn.dataset.heartSetup) return true;
      xbBtn.dataset.heartSetup = '1';

      // Referenzen VOR dem Verschieben sichern
      var xbWrapDiv = xbBtn.closest('.xb-wishlist-button');
      var xbBlock   = xbBtn.closest('.product__block');

      // Klick nicht an Zoom/Lightbox weitergeben
      xbBtn.addEventListener('click', function(e) {
        e.stopPropagation();
      }, true);

      // Ziel-Container: product-images Custom Element
      var mediaContainer =
        document.querySelector('product-images') ||
        document.querySelector('.product__images');

      if (!mediaContainer) return false;

      if (!mediaContainer.contains(xbBtn)) {
        // position:relative direkt als inline-style setzen
        mediaContainer.style.position = 'relative';
        xbBtn.classList.add('product__heart-overlay');
        mediaContainer.appendChild(xbBtn);
      } else {
        xbBtn.classList.add('product__heart-overlay');
      }

      // Originale Container verstecken (Referenzen gespeichert bevor wir verschoben haben)
      if (xbWrapDiv) xbWrapDiv.style.display = 'none';
      if (xbBlock)   xbBlock.style.display   = 'none';

      return true;
    }

    function findXBButton() {
      return document.querySelector('.xb-wishlist-button__add-style:not([data-heart-setup])');
    }

    var xbBtn = findXBButton();
    if (xbBtn) {
      setupHeartButton(xbBtn);
    } else {
      var attempts = 0;
      var heartInterval = setInterval(function() {
        var btn = findXBButton();
        if (btn) {
          setupHeartButton(btn);
          clearInterval(heartInterval);
        } else if (++attempts > 40) {
          clearInterval(heartInterval);
        }
      }, 250);
    }

  });
})();
